<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-bug-check</v-icon>{{$t('qualitycheck.value.types')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <QualityCheckValueTypeForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import QualityCheckValueTypeForm from '../../components/qualitycheckvaluetype/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'QualityCheckValueType';

const { mapFields } = createHelpers({
  getterType: 'qualitycheckvaluetype/getField',
  mutationType: 'qualitycheckvaluetype/updateField'
});

export default {
  name: 'QualityCheckValueTypeCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    QualityCheckValueTypeForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('qualitycheckvaluetype', ['create', 'reset'])
  }
};
</script>
